<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" title="Teapplix" width="500">
      <el-form :inline="false"  class="" style="text-align: left">
        <el-form-item  label="RII出库单号">
          <el-input style="width:200px" disabled v-model="formInline.riiNumber" ></el-input>
        </el-form-item>
        <el-form-item  label="copilot单号">
          <el-input style="width:200px" disabled v-model="formInline.trackNumber" ></el-input>
        </el-form-item>
        <el-form-item  label="发货时间">
          <el-date-picker
              style="width: 200px"
              v-model="formInline.ShipDate"
              type="datetime"
              placeholder="请选择发货时间"
              :default-time="defaultTime"
          />
        </el-form-item>
        <el-form-item  label="物流商">
          <el-select
              v-model="formInline.CarrierName"
              filterable
              default-first-option
              :reserve-keyword="false"
              placeholder="请选择物流商"
              style="width: 200px"
          >
            <el-option
                v-for="item in defaultCarrierOption"
                :key="item.name"
                :label="item.name"
                :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item  label="发货方式">
          <el-select
              v-model="formInline.ShipMethod"
              default-first-option
              :reserve-keyword="false"
              placeholder="请选择发货方式"
              style="width: 200px"
          >
            <el-option
                v-for="item in defaultShipOption"
                :key="item.name"
                :label="item.name"
                :value="item.value"
            />
          </el-select>
        </el-form-item>

        <div class="flex flex-row-right flex-item-center">
          <div>
            <el-button style="margin: 0 auto" type="primary" @click="submit">上传Teapplix</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,ElSelect,ElOption,ElDatePicker
} from "element-plus";
import {addTeapplix} from "@/utils/api"
export default {
  name: "addTeapplix",
  components:{
    ElDialog,ElForm,ElFormItem,ElInput,ElButton,ElSelect,ElOption,ElDatePicker
  },
  data(){
    return{
      dialogTableVisible:false,
      defaultTime: new Date(),
      formInline:{
        CarrierName:'Pilot Freight Services',
        ShipMethod:'PAAF',
        ShipDate:new Date()
      },
      defaultCarrierOption:[
        {'name':'Pilot Freight Services',value:'Pilot Freight Services'}
      ],
      defaultShipOption:[
        {'name':'PAAF',value:'PAAF'},
        {'name':'GROUNDADV/RECTPARCEL',value:'GROUNDADV/RECTPARCEL'},
      ]
    }
  },
  methods:{
    open(data){
      this.dialogTableVisible = true
      this.formInline = {...this.formInline,...data}
    },
    submit(){
      addTeapplix(this.formInline).then(res=>{
        this.dialogTableVisible = false
        this.$emit('close',res.Data)
      }).catch(err=>{
        this.$emit('close',err)
      })

    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 150px;
}
</style>